import config from "../config";
import request, {
  requestOptions,
  requestOptionsFormData,
} from "../utils/request";

const baseUrl = `${config.API_ROOT}/app/contacts`;
const contactsListBaseUrl = `${config.API_ROOT}/app/contacts/list`;

const Contacts = {
  async search(string, companies) {
    const options = await requestOptions("POST", { companies }, true);
    const url = `${baseUrl}/search?q=${string}`;
    return request(url, options);
  },
  async get() {
    const options = await requestOptions("GET", {}, true);
    const url = `${baseUrl}/`;
    return request(url, options);
  },
  async getMessages(contactId) {
    const options = await requestOptions("GET", {}, true);
    const url = `${baseUrl}/${contactId}/messages`;
    return request(url, options);
  },
  async postMessages(contactId, body) {
    const options = await requestOptions("POST", body, true);
    const url = `${baseUrl}/${contactId}/messages`;
    return request(url, options);
  },
  async uploadMedia(contactId, formData) {
    const options = await requestOptionsFormData(formData, true);
    const url = `${baseUrl}/${contactId}/media`;
    return request(url, options);
  },
  async readMessages(contactId, messageId) {
    const options = await requestOptions("POST", {}, true);
    const url = `${baseUrl}/${contactId}/messages/${messageId}`;
    return request(url, options);
  },
  async putEnabled(contactId, body) {
    const options = await requestOptions("PUT", body, true);
    const url = `${baseUrl}/${contactId}/enabled`;
    return request(url, options);
  },
  async putBlocked(contactId, body) {
    const options = await requestOptions("PUT", body, true);
    const url = `${baseUrl}/${contactId}/blocked`;
    return request(url, options);
  },
  async putArchive({ contactId, archive }) {
    const options = await requestOptions("PUT", { archive }, true);
    const url = `${baseUrl}/${contactId}/archive`;
    const { data, err } = await request(url, options);
    if (err) {
      throw err;
    }

    return data;
  },
  async escalateContact(contactId, body) {
    const options = await requestOptions("PUT", body, true);
    const url = `${baseUrl}/${contactId}/manual-escalation`;
    return request(url, options);
  },
  async runConversational(contactId) {
    const options = await requestOptions("POST", {}, true);
    const url = `${baseUrl}/${contactId}/run-converational`;
    return request(url, options);
  },
  async putSolveEscalations(contactId) {
    const options = await requestOptions("PUT", {}, true);
    const url = `${baseUrl}/${contactId}/solve-escalations`;
    return request(url, options);
  },
  async getContacts({ filter, pageParam, limit = 50 }) {
    const options = await requestOptions(
      "POST",
      {
        filters: filter
          .filter((f) => f.isActive)
          .map((f) => ({
            label: f.label,
            value: f.value,
          })),
        cursor: pageParam,
        limit,
      },
      true,
    );
    const { data } = await request(contactsListBaseUrl, options);
    return data;
  },
  async getContact(contactId) {
    const options = await requestOptions("GET", {}, true);
    const url = `${contactsListBaseUrl}/${contactId}`;
    const { data } = await request(url, options);
    return data?.contact || {};
  },
  async getCounts() {
    const options = await requestOptions("GET", {}, true);
    const url = `${baseUrl}/count`;
    const { data } = await request(url, options);
    return data?.counters || undefined;
  },
};

export default Contacts;
